import SpeechTransition from './SpeechTransition'
import CoursesFactTransition from './CoursesFactTransition'
import DoubleBubbleTransition from './DoubleBubbleTransition'
import TipsTransition from './TipsTransition'

export default {
  SpeechTransition,
  CoursesFactTransition,
  DoubleBubbleTransition,
  TipsTransition
}
